import React, { useState } from "react";
import { Col, Container, Row, Button, Modal } from "reactstrap";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FaYoutube } from "react-icons/fa6";
import previewBadgeseosonal from "../assets/img/custom/seosonal_preview_badge.png";

function SeasonalSystem() {
  const [modal, setModal] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);

  const toggle = () => setModal(!modal);

  const handleSiteSelection = (site) => {
    setSelectedSite(site);
    toggle();
  };

  const getContinueLink = () => {
    if (selectedSite === "fan") {
      return "https://fhp-fans.web.app/auth/login?redirect=/fan/badges-gallery-seasonal";
    } else if (selectedSite === "athlete") {
      return "https://fans-help-players-athlete.web.app/auth/login?redirect=/admin/seasonal-badges";
    }
    return "#";
  };

  return (
    <>
      <div className="trending">
        <Button className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </Button>{" "}
        <Container className="SeasonalSystem-Container">
          <div className="SeasonalSystem ">
            <a
              className="text-white btn btn-primary "
              href="https://youtu.be/iOAuhUd-om0"
              target="_blank"
            >
              <FaYoutube className="youtube-icon" /> Play Video
            </a>
            <Button
              className=" mt-2 "
              color="primary"
              onClick={() => handleSiteSelection("fan")}
            >
              Go to fan site
            </Button>
            <Button
              className=" mt-2 "
              color="primary"
              onClick={() => handleSiteSelection("athlete")}
            >
              Go to athlete site
            </Button>
          </div>
        </Container>
      </div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="xl"
        className="modal-dialog modal-dialog-centered"
      >
        <Row>
          <Col lg="12">
            <div className="complaint-card shadow">
              <Row className="p-3">
                <Col className="col-7">
                  <div className="border border-dark">
                    <h1 className="font-weight-bolder text-center">
                      SEASONAL BADGES & VIEWS
                    </h1>
                  </div>
                  <p className="font-weight-normal mt-2">
                    We think you are great, so we want you to{" "}
                    <b className="text-danger">
                      You are REALLY GOING TO ENJOY&nbsp;
                    </b>
                    <b className="text-primary">SEASONAL BADGES&nbsp;</b>
                    <b className="text-danger">& INSTANT ONLINE VIDEO VIEWS</b>
                  </p>
                  <p className="font-weight-normal mt-2">
                    These&nbsp;
                    <b className="text-dark ">
                      SEASONAL&nbsp; at{" "}
                      <b>
                        <b className="text-dark">Fans</b>
                        <b className="text-primary">Help</b>
                        <b className="text-danger">Players</b>
                      </b>{" "}
                    </b>
                    can be of two types. The first is an&nbsp;
                    <b className="text-danger">
                      ONLINE VIDEO made by a Student Athlete.
                    </b>
                    &nbsp;The second is a&nbsp;
                    <b className="text-danger">CARD with QR</b>&nbsp; code you
                    scan to see a&nbsp;
                    <b className="text-danger">
                      linked video of SPORTS ANALYSIS made by the
                    </b>
                    &nbsp;{" "}
                    <b className="text-primary">
                      Student Athlete of Your Choice.
                    </b>
                  </p>

                  <p className="font-weight-normal mt-2">
                    HERE’S another important thing to Remember– up to{" "}
                    <b className="text-dark ">
                      <b className="text-danger">88%</b> of the money spent at{" "}
                      <b className="text-dark">F</b>
                      <b className="text-primary">H</b>
                      <b className="text-danger">P </b>
                      <b className="text-dark">goes </b>
                      <b className="text-danger">
                        directly to Student Athletes.
                      </b>
                    </b>
                  </p>
                  <p className="font-weight-normal mt-2">
                    <b className="text-dark">THANK YOU!</b>{" "}
                    <u className="text-dark">Enjoy</u> and{" "}
                    <b className="text-dark">
                      <u>TELL YOUR FRIENDS.</u>
                    </b>
                  </p>
                </Col>
                <Col className="col-5">
                  <div className="w-full mt-5 mb-3 d-flex justify-content-center">
                    <img src={previewBadgeseosonal} height={200} />
                  </div>

                  <div className="d-flex justify-content-center align-items-center mt-5">
                    {/* <Button color="primary"> */}
                    <a
                      href="https://www.youtube.com/watch?v=iOAuhUd-om0​"
                      target="_blank"
                      className="text-white btn btn-primary"
                    >
                      Play Video
                    </a>
                    {/* </Button> */}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      href={getContinueLink()}
                      className="btn btn-primary"
                      target="_blank"
                    >
                      Continue
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Modal>
    </>
  );
}

export default SeasonalSystem;
